<g-select
	class="sort-type"
	[items]="sortOptions"
	[selectedOption]="selectedSortOption?.column"
	(selectChange)="dropdownValueChanged($event)"
	bindKey="column"
	[selectedLabelFormatter]="labelFormatter"
/>
@if (selectedSortOption) {
	<button
		data-cy="toggle-sort-direction"
		class="sort-direction"
		(click)="toggleSortDirection()"
		i18n-title
		title="Toggle sort direction"
	>
		<g-icon [icon]="sortIcon" />
	</button>
}
